import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const GroupIcon = (props: IconProps) => (
  <Icon width="18px" height="18px" viewBox="0 0 18 18" {...props}>
    <path d="M14.25 2.25H3.75c-.825 0-1.5.675-1.5 1.5v10.5c0 .825.675 1.5 1.5 1.5h10.5c.825 0 1.5-.675 1.5-1.5V3.75c0-.825-.675-1.5-1.5-1.5Zm0 1.5V6H3.75V3.75h10.5Zm0 3.75v3H3.75v-3h10.5Zm-10.5 6.75V12h10.5v2.25H3.75Z" />
  </Icon>
);

export default memo(GroupIcon);
